"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledSystem = require("styled-system");

var _margin = _interopRequireDefault(require("./margin"));

var _padding = _interopRequireDefault(require("./padding"));

var space = (0, _styledSystem.compose)(_styledSystem.space, _margin.default, _padding.default); // eslint-disable-next-line security/detect-object-injection

space.css = function (type, value) {
  return function (props) {
    var _space$type;

    return space[type]((_space$type = {
      theme: props.theme
    }, _space$type[type] = value, _space$type));
  };
};

var _default = space;
exports.default = _default;